module.exports = __webpack_public_path__ + "static/media/yandex.977a2f21.png";